import apiService from '../../../apiService'
import Notification from '../../../../../../../../resources/js/notification'

export default {
  namespaced: true,
  state: {
    regions: [],
    fetching: true,
    selected: null
  },
  getters: {
    getRegions (state) {
      return state.regions
    }
  },
  mutations: {
    setRegions (state, regions) {
      state.regions = regions
    },
    setSelected (state, region) {
      state.selected = region
    }
  },
  actions: {
    /**
     * Метод-обёртка над запросом к API /api/serm/regions
     * @returns {Promise<AxiosResponse<T>>}
     */
    fetch ({ state, commit }, domain) {
      state.fetching = true
      apiService.getRegions(domain)
        .then(response => {
          commit('setRegions', response.data)
          window.vue.$emit('serm/regionsLoaded')
          state.fetching = false
        })
        .catch(() => {
          state.fetching = false
          Notification.notifyError({
            title: 'Ошибка',
            content: 'Не удалось загрузить список регионов.'
          })
        })
    },
    changeSelected ({ state, commit, dispatch }, selected) {
      commit('setSelected', selected)
      window.vue.$emit('serm/regionSelected')
    }
  }
}
